/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_GroupInputs */

const en_users_group = /** @type {(inputs: Users_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groups`)
};

const pt_br2_users_group = /** @type {(inputs: Users_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupos`)
};

/**
* | output |
* | --- |
* | "Groups" |
*
* @param {Users_GroupInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_group = /** @type {((inputs?: Users_GroupInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_GroupInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_group(inputs)
	return pt_br2_users_group(inputs)
});